import React, { useState, useRef, useEffect } from 'react';
import { Divider, Steps, Input, Button } from 'antd';
import ApiServices from '~services';
import Utils from '~commons/utils';

import './refused-all-modal.css';

const STEP_STATUS = {
  1: {
    title: 'Đang chờ',
    color: 'gray',
    marginTitle: '28px',
    marginSub: '90px',
  },
  2: {
    title: 'Đang xử lý',
    color: 'blue',
    marginTitle: '18px',
    marginSub: '90px',
  },
  3: {
    title: 'Thành công',
    color: 'green',
    marginTitle: '12px',
    marginSub: '90px',
  },
  4: {
    title: 'Thất bại',
    color: 'red',
    marginTitle: '36px',
    marginSub: '90px',
  },
};

const RefusedAllModal = ({
  dataSelect = [],
  onClose,
  setReloadAfterRefusedAll,
  loadingRefusedAll,
  setLoadingRefusedAll,
}) => {
  const itemRefs = useRef({});

  const [currentStatus, setCurrentStatus] = useState(0);
  const [itemList, setItemList] = useState([]);

  const [reasonRefused, setReasonRefused] = useState('');

  const [countProcess, setCountProcess] = useState(0);
  const [countSuccess, setCountSuccess] = useState(0);
  const [countFailed, setCountFailed] = useState(0);

  const [actionConfirm, setActionConfirm] = useState(false);

  useEffect(() => {
    setCurrentStatus(0);
    setReasonRefused('');
    setCountProcess(0);
    setCountSuccess(0);
    setCountFailed(0);
    setActionConfirm(false);

    if (dataSelect) {
      const newData = dataSelect?.map((el) => {
        el.stepStatus = 1;
        el.errorMessage = '';
        return el;
      });
      setItemList(newData);
    } else {
      setItemList([]);
    }
  }, [dataSelect]);

  const scrollToItem = (id) => {
    itemRefs.current[id]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  };

  useEffect(() => {
    scrollToItem(currentStatus);
  }, [currentStatus]);

  const handleRefused = async (dataRefused, indexRefused, note) => {
    if (!dataRefused || !dataRefused?.auto_ID || !dataRefused?.booking_ID || !note) return;

    const dataSend = {
      ids: [`${dataRefused?.auto_ID}`, `${dataRefused?.booking_ID}`],
      note,
    };

    try {
      const res = await ApiServices.refusedRVS(dataSend);
      if (res?.data) {
        setItemList((prev) => {
          prev[indexRefused].stepStatus = 3;

          return prev;
        });

        setCountSuccess((prev) => {
          return prev + 1;
        });
      }
    } catch (error) {
      console.log(`error:::`, error);

      setItemList((prev) => {
        prev[indexRefused].stepStatus = 4;
        prev[indexRefused].errorMessage = error;

        return prev;
      });
      setCountFailed((prev) => {
        return prev + 1;
      });
    } finally {
      setCurrentStatus((prev) => prev + 1);
      setCountProcess((prev) => {
        return prev + 1;
      });

      // end process
      if (indexRefused === itemList?.length - 1) {
        setLoadingRefusedAll(false);
      }
    }
  };

  const handleConfirm = async (note) => {
    console.log('Submit Form:::', note);

    if (!note) return;

    setLoadingRefusedAll(true);
    setReloadAfterRefusedAll(true);
    setActionConfirm(true);

    dataSelect?.map((dataRefused, indexRefused) => {
      setItemList((prev) => {
        prev[indexRefused].stepStatus = 2;

        return prev;
      });

      handleRefused(dataRefused, indexRefused, note);
    });
  };

  const handleChangeReasonRefused = (event) => {
    const value = event.target?.value ?? '';

    setReasonRefused(value);
  };

  const renderFormatData = (title = '', data = '') => {
    return (
      <span>
        <span>{title}</span>: <span style={{ color: 'blue' }}>{data}</span>
      </span>
    );
  };

  // const renderItems = (item, index) => {
  //   item.title = (
  //     <span
  //       key={index}
  //       ref={(el) => {
  //         itemRefs.current[index] = el;
  //       }}
  //     >
  //       <span
  //         style={{
  //           marginRight: STEP_STATUS[item.stepStatus].marginTitle,
  //           color: STEP_STATUS[item.stepStatus].color,
  //         }}
  //       >
  //         {STEP_STATUS[`${item.stepStatus}`].title}
  //       </span>
  //       {renderFormatData('Booking', item?.so_Booking)}
  //       <span style={{ marginLeft: '10px' }}></span>
  //       {renderFormatData('Kh.Hàng', item?.ten_Khach_Hang)}
  //     </span>
  //   );
  //   item.description = (
  //     <span key={item?.index}>
  //       <span style={{ marginRight: STEP_STATUS[item.stepStatus].marginSub }}></span>
  //       {renderFormatData('Ngày Booking', item?.ngay_Booking)}
  //       <span style={{ marginLeft: '10px' }}></span>
  //       {renderFormatData('Ngày Cắt Máng', item?.ngay_Cat_Mang)}
  //       <span style={{ marginLeft: '10px' }}></span>
  //       {renderFormatData('Ngày Cắt SI', item?.ngay_Cat_SI)}
  //       {item?.errorMessage && (
  //         <div style={{ marginLeft: STEP_STATUS[item.stepStatus].marginSub, color: 'red' }}>
  //           <span>* Lỗi: {item?.errorMessage}</span>
  //         </div>
  //       )}
  //     </span>
  //   );
  //   return item;
  // };

  const renderItems = (item, index) => {
    return {
      title: (
        <span
          ref={(el) => {
            itemRefs.current[index] = el;
          }}
        >
          <span
            style={{
              marginRight: STEP_STATUS[item.stepStatus].marginTitle,
              color: STEP_STATUS[item.stepStatus].color,
            }}
          >
            {STEP_STATUS[item.stepStatus].title}
          </span>

          {renderFormatData('Booking', item?.so_Booking)}

          <span style={{ marginLeft: '10px' }} />

          {renderFormatData('Kh.Hàng', item?.ten_Khach_Hang)}
        </span>
      ),

      description: (
        <span>
          <span
            style={{
              marginRight: STEP_STATUS[item.stepStatus].marginSub,
            }}
          />

          {renderFormatData('Ngày Booking', Utils.formatDateFn(item?.ngay_Booking))}

          <span style={{ marginLeft: '10px' }} />

          {renderFormatData('Ngày Cắt Máng', Utils.formatDateFn(item?.ngay_Cat_Mang))}

          <span style={{ marginLeft: '10px' }} />

          {renderFormatData('Ngày Cắt SI', Utils.formatDateFn(item?.ngay_Cat_SI))}

          {item?.errorMessage && (
            <div
              style={{
                marginLeft: STEP_STATUS[item.stepStatus].marginSub,
                color: 'red',
              }}
            >
              <span>* Lỗi: {item?.errorMessage}</span>
            </div>
          )}
        </span>
      ),
    };
  };

  return (
    <div className='container-refused-modal'>
      <div>
        <b>Lý Do Từ Chối: </b>
        <span className='red'>(*)</span>
      </div>

      <Input.TextArea
        placeholder='Lý Do Từ Chối'
        required
        disabled={actionConfirm}
        value={reasonRefused}
        onChange={handleChangeReasonRefused}
      />
      <Divider />
      <div className='steps-box-refused-modal'>
        <Steps
          progressDot
          current={currentStatus || 0}
          direction='vertical'
          items={itemList?.map(renderItems)}
        />
      </div>

      <div
        style={{
          display: 'flex',
        }}
      >
        <div className='box-result-refused-modal'>
          <span>{renderFormatData('Xử lý', `${countProcess}/${itemList?.length}`)}</span>
          <span
            style={{
              marginLeft: '10px',
            }}
          >
            {renderFormatData('Thành công', countSuccess)}
          </span>
          <span
            style={{
              marginLeft: '10px',
            }}
          >
            {renderFormatData('Thất bại', countFailed)}
          </span>
        </div>
        <div className='box-button-submit-refused-modal'>
          {loadingRefusedAll ? (
            <div>
              <span className='processing-text'>
                Đang từ chối<span className='dots'></span>
              </span>
            </div>
          ) : (
            <div>
              <Button type='danger' className='button-submit-refused-modal' onClick={onClose}>
                Đóng
              </Button>
              {!actionConfirm && (
                <Button
                  disabled={!reasonRefused}
                  type='primary'
                  className='button-submit-refused-modal'
                  onClick={() => handleConfirm(reasonRefused)}
                >
                  Xác nhận
                </Button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export { RefusedAllModal };
